"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractImpersonationHeader = void 0;
const extractImpersonationHeader = (headers) => {
    if (headers == null) {
        return false;
    }
    const impersonated = headers['x-session-state']
        ? JSON.parse(headers['x-session-state']).impersonation
        : false;
    return impersonated ? true : false;
};
exports.extractImpersonationHeader = extractImpersonationHeader;
//# sourceMappingURL=converter.helper.js.map